import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoGa: CultureInfo = {
  name: 'ga',
  displayName: 'Irish',
  iso3LanguageCode: 'gle',
  iso2LanguageCode: 'ga',
  ietfLanguageTag: 'ga',
  parent: null
};
